function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M87.4 29.8C85.8 14 72.4 1.6 56.1 1.6H45.3c-17.4 0-31.5 14.1-31.5 31.5v27.4h2.1c6.3 0 11.4 5.1 11.4 11.4 0 2.5-.9 4.8-2.3 6.7h4.2c6.3 0 11.4 5.1 11.4 11.4 0 2.6-1 5.1-2.5 7 14.5 4.6 29.3-1.5 29.3-1.5 11.8-4.5 20.2-16 20.2-29.4 0-2.3-1.8-4.1-4.1-4.1H67.3c-2.3 0-4.1 1.8-4.1 4.1 0 3.9-3.2 7.1-7.1 7.1H45.3c-3.9 0-7.1-3.2-7.1-7.1v-33c0-3.9 3.2-7.1 7.1-7.1h6.8c2.1 0 3.8 1.7 3.8 3.8v15c0 3.3 2.2 6.4 5.5 7 4.4.9 8.2-2.5 8.2-6.7v-5.8c0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2v1.2c0 3.3 2.2 6.4 5.5 7 4.4.9 8.2-2.5 8.2-6.7V33.1l-.3-3.3z",
    style: {
      fill: "current"
    }
  }));
};

export default SvgLogo;